import { render } from "./FormCatastro.vue?vue&type=template&id=0c3177db&scoped=true"
import script from "./FormCatastro.vue?vue&type=script&lang=js"
export * from "./FormCatastro.vue?vue&type=script&lang=js"

import "./FormCatastro.vue?vue&type=style&index=0&id=0c3177db&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c3177db"

export default script